export default `
  subscription OnToggleCardReaction($workflowId: String) {
    onToggleCardReaction(workflowId: $workflowId) {
      workflowId
      cardId
      direction
      user {
        id
        firstname
        lastname
      }
    }
  }
`
